
import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { ActivitiesMortgageRoutes } from '../../../routes';

export const ActivitiesMortgageLayout = () => {
  return <SwitchRoute routes={ActivitiesMortgageRoutes} />;
};

